export default [
  { label: 'Minutes', value: 'timestamp-minute-of-day' },
  { label: 'Hours', value: 'timestamp-hour-of-day' },
]
